export default __webpack_public_path__ + "static/nico-bryant-aguilar@2x-79ab4a092eb7ead1736bfd55c2931453.webp";